import { put, call, takeLatest } from 'redux-saga/effects';
import types from './actionTypes';
import * as localAgenciesActions from './actions';
import apiCall from '../../helpers/axiosApiCallWrapper';
import toastr from 'toastr';

function* syncLocalAgenciesSaga({ params }) {
  try {
    const { agencies } = yield call(
      apiCall,
      'POST',
      `/getLocalAgencies`,
      params,
    );

    yield put(localAgenciesActions.syncLocalAgenciesSuccess(agencies));
  } catch (error) {
    yield put(localAgenciesActions.syncLocalAgenciesFailure(error));
    toastr.error('Error syncing local agencies');
  }
}

function* localAgencySaga() {
  yield takeLatest(types.SYNC_LOCAL_AGENCIES.REQUEST, syncLocalAgenciesSaga);
}

export default localAgencySaga;
